import { addGetParameters, sendGetRequest } from "@/helper/requests"
import selectors from "@/urls/selectors"

const state = {
  selectors: {
    olympiads: [],
    regions: [],
    partnersTags: [],
    partnersRegions: [],
  }
}

const getters = {
  olympiads: state => state.selectors.olympiads,
  regions: state => state.selectors.regions,
  partnersTags: state => state.selectors.partnersTags,
  partnersRegions: state => state.selectors.partnersRegions,
}

const mutations = {
  SET_OLYMPIADS: (state, value) => {
    state.selectors.olympiads = value
  },
  SET_REGIONS: (state, value) => {
    state.selectors.regions = value
  },
  SET_PARTNERS_TAGS: (state, value) => {
    state.selectors.partnersTags = value
  },
  SET_PARTNERS_REGIONS: (state, value) => {
    state.selectors.partnersRegions = value
  },
}

const actions = {
  loadOlympiads: ({ commit }, { url, params, finalizer, catcher }) => {
    if (!url) url = selectors.SELECTORS.OLYMPIADS()
    if (params) {
      url = addGetParameters(url, params)
    }
    sendGetRequest(
      url, (data, url) => {
        commit('SET_OLYMPIADS', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadRegions: ({ commit }, { url, params, finalizer, catcher }) => {
    if (!url) url = selectors.SELECTORS.REGIONS()
    if (params) {
      url = addGetParameters(url, params)
    }
    sendGetRequest(
      url, (data, url) => {
        commit('SET_REGIONS', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadPartnersTags: ({ commit }, { url, params, finalizer, catcher }) => {
    if (!url) url = selectors.SELECTORS.PARTNERS_TAGS()
    if (params) {
      url = addGetParameters(url, params)
    }
    sendGetRequest(
      url, (data, url) => {
        commit('SET_PARTNERS_TAGS', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadPartnersRegions: ({ commit }, { url, params, finalizer, catcher }) => {
    if (!url) url = selectors.SELECTORS.PARTNERS_REGIONS()
    if (params) {
      url = addGetParameters(url, params)
    }
    sendGetRequest(
      url, (data, url) => {
        commit('SET_PARTNERS_REGIONS', data)
        finalizer(data, url)
      }, catcher
    )
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
